<app-booking *ngIf="english"></app-booking>
<app-booking-hindi *ngIf="hindi"></app-booking-hindi>